
import { Component, Vue, Prop } from 'vue-property-decorator'
const TypesMap = {
    1: '技术'
}
/**
 * 
 * @prop value  表格数据
 * @emit delete 删除记录
 * 
*/
@Component({
    name: 'recruit-table'
})
export default class extends Vue {
    @Prop({ required: true }) private value!: any[]

    private onRegionFormat(row: any) {
        return row.province + ',' + row.city
    }

    private onTypeFormat(row: any) {
        return Reflect.get(TypesMap, row.type)
    }
}
